export default {
  Home: '/',
  Get: '/get'
}



// WEBPACK FOOTER //
// ./src/pages/routes.js